module.exports = __webpack_public_path__ + "d6103958c2f7c4351ee74e6e0a540b3c.png";